import axios from 'axios';
import { loginreq, req, reqPost } from './axiosFun';
const BASE_URL="";
// 登录接口
export const login = (params) => { return reqPost(BASE_URL+"/api/user/login", params) };
// 获取用户菜单
export const menu = (params) => { return axios.get(BASE_URL+"/api/menu?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 退出接口
export const loginout = () => { return axios.delete(BASE_URL+"/api/login?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 用户管理
 **/
// 用户管理-获取用户列表
export const userList = (params) => { return reqPost(BASE_URL+"/api/user/getUserPage", params) };
// 用户管理-修改用户状态
export const changeUserStatus=(params)=>{return axios.post(BASE_URL+"/api/user/changeUserStatus",params).then(res => res.data)}
// 用户管理-重置密码
export const userPwd =(params)=>{return axios.post(BASE_URL+"/api/user/rechargePassword",params).then(res => res.data)}
// 用户管理-用户下线
export const userExpireToken =(params)=>{return axios.post(BASE_URL+"/api/user/offline",params).then(res => res.data)}

/**
 * 员工管理
 **/
// 保存或修改员工信息
export const saveOrUpdateStaff = (params) => { return reqPost(BASE_URL+"/api/staff/entryStaff", params) };
export const queryStaffPageList=(params)=>{return reqPost(BASE_URL+"/api/staff/getStaffPage", params) }
// 当前登录人关联的门店列表：员工页按门店隔离后，关联多家店的业主靠它切店
export const getUserMchList=()=>{return reqPost(BASE_URL+"/api/mch/getUserMchList", {}) }

// 用户管理-数据权限
export const UserDeptTree = (params) => { return axios.get(BASE_URL+"/api/UserDept/tree/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 用户管理-数据权限保存
export const UserDeptSave = (params) => { return req("post", BASE_URL+"/api/UserDept/save", params) };
// 用户管理-刷新缓存
export const userFlashCache = (params) => { return req("get", BASE_URL+"/api/User/flashCache/" + params, {}) };

// 绩效管理-获取绩效列表
export const performanceTemplatePage = (params) => { return reqPost(BASE_URL+"/api/performanceTemplate/getPerformanceTemplate", params) };
// 绩效管理-添加绩效模板
export const savePerformanceTemplate=(params)=>{return reqPost(BASE_URL+"/api/performanceTemplate/savePerformanceTemplate",params).then(res => res.data)}
// 绩效管理-修改绩效模板
export const updatePerformanceTemplate=(params)=>{return reqPost(BASE_URL+"/api/performanceTemplate/updatePerformanceTemplate",params).then(res => res.data)}
// 绩效管理-删除绩效模板
export const delPerformanceTemplatePage = (params) => { return axios.delete(BASE_URL+"/api/performanceTemplate/delPerformanceTemplate?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 绩效管理-获取所有用户的绩效列表
export const getAllStaffTemplateList= () => { return axios.get(BASE_URL+"/api/performanceTemplate/getAllStaffTemplateList?token=" + localStorage.getItem('logintoken')) };

// 奖励管理-获取奖励列表
export const rewardTemplatePage = (params) => { return reqPost(BASE_URL+"/api/rewardTemplate/getRewardTemplate", params) };
// 奖励管理-添加奖励模板
export const saveRewardTemplate=(params)=>{return reqPost(BASE_URL+"/api/rewardTemplate/saveRewardTemplate",params)}
// 奖励管理-修改奖励模板
export const updateRewardTemplate=(params)=>{return reqPost(BASE_URL+"/api/rewardTemplate/updateRewardTemplate",params)}
// 奖励管理-删除奖励模板
export const delRewardTemplatePage = (params) => { return axios.delete(BASE_URL+"/api/rewardTemplate/delRewardTemplate?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

// 绩效奖励
export const staffRewardPage = (params) => { return reqPost(BASE_URL+"/api/staffReward/getStaffRewardPage", params) };
// 修改绩效奖励
export const updateStaffReward = (params) => { return reqPost(BASE_URL+"/api/staffReward/updateStaffReward", params) };
// 删除绩效奖励
export const delStaffReward = (params) => { return axios.delete(BASE_URL+"/api/staffReward/delStaffReward?rewardId=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };



/**
 * 角色管理
 **/
// 角色管理-获取角色列表
export const roleList = (params) => { return reqPost( BASE_URL+"/api/role/getRolePage", params) };
// 角色管理-保存（添加编辑）
export const roleSave = (params) => { return reqPost(BASE_URL+"/api/role/addRoleOrUpdate", params) };
// 角色管理-删除角色
export const roleDelete = (params) => { return axios.delete(BASE_URL+"/api/role/delRole?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 修改角色状态
export const changeRoleStatus=(params)=>{return axios.post(BASE_URL+"/api/role/changeRoleStatus",params).then(res => res.data)}
// 角色管理-菜单权限（获取）
export const RoleRightTree = (params) => { return axios.get(BASE_URL+"/api/menu/getMenuTreeByRoleId/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 角色管理-菜单权限（保存）
export const RoleRightSave = (params) => { return reqPost(BASE_URL+"/api/role/saveOrUpdateMenusByRole", params) };
// 根据token获取所有角色
export const getAllMchRoleList= () => { return axios.get(BASE_URL+"/api/role/getAllMchRole?token=" + localStorage.getItem('logintoken')) };

/**
 * 商户管理
 **/
// 商户管理-获取商户列表
export const mchList = (params) => { return reqPost( BASE_URL+"/api/mch/getMchPage", params) };
// 商户管理-修改商户状态
export const changeMchStatus=(params)=>{return axios.post(BASE_URL+"/api/mch/changeMchStatus",params).then(res => res.data)}
// 商户管理-保存（添加编辑）
export const mchSave = (params) => { return reqPost( BASE_URL+"/api/mch/registrationMerchant", params) };
// 公司管理-删除公司
export const deptDelete = (params) => { return axios.get(BASE_URL+"/api/Dept/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 系统环境变量
 **/
// 系统环境变量-获取系统环境变量列表
export const variableList = (params) => { return req("post", BASE_URL+"/api/Variable/list", params) };
// 系统环境变量-保存（添加编辑）
export const variableSave = (params) => { return req("post", BASE_URL+"/api/Variable/save", params) };
// 系统环境变量-删除系统环境变量
export const variableDelete = (params) => { return axios.delete(BASE_URL+"/api/Variable/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 权限管理
 **/
// 权限管理-获取权限列表
export const permissionList = (params) => { return req("post", BASE_URL+"/api/Permission/list", params) };
// 权限管理-保存权限
export const ermissionSave = (params) => { return req("post", BASE_URL+"/api/Permission/save", params) };
// 权限管理-删除权限
export const ermissionDelete = (params) => { return axios.delete(BASE_URL+"/api/Permission/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 权限管理-获取权限
export const roleDropDown = () => { return axios.get(BASE_URL+"/api/Role/dropDown/all?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 权限管理-配置权限
export const RolePermission = (params) => { return req("post", BASE_URL+"/api/RolePermission/save", params) };



// WEBPACK FOOTER //
// ./src/api/userMG.js